export default "__VITE_ASSET__4a48879d__"